module.exports = __webpack_public_path__ + "img/signature_1.beb33b76.png";